export default function PrivacyPolicy() {
  return (
    <div className="privacy-wrapper">

      <h1>Privacy Policy</h1>
      <p>
        This Privacy Policy explains how we collect, use, and protect your
        information when you visit and use this website.
      </p>

      <div className="privacy-section">
        <h2>Information We Collect</h2>
        <p>
          We do not collect any personally identifiable information unless you
          explicitly provide it (for example, through a contact form).
        </p>
      </div>

      <div className="privacy-section">
        <h2>Google AdSense & Cookies</h2>
        <p>
          This website uses Google AdSense which uses cookies to show personalized
          ads based on your visits to this and other websites.
        </p>
        <p>
          Users may opt out of personalized ads by visiting: https://adssettings.google.com
        </p>
      </div>

      <div className="privacy-section">
        <h2>Third-Party Services</h2>
        <p>
          Third-party ad networks may use cookies, JavaScript, or Web Beacons to
          measure ads effectiveness or personalize content.
        </p>
      </div>

      <div className="privacy-section">
        <h2>Data Protection</h2>
        <p>
          We do not sell, trade, or transfer your personal information to outside parties.
        </p>
      </div>

      <div className="privacy-section">
        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy occasionally. Updates will be posted here.
        </p>
      </div>

      <div className="privacy-section">
        <h2>Contact Us</h2>
        <p>
          If you have any questions, please contact us using the Contact page.
        </p>
      </div>

    </div>
  );
}
